import React from 'react'
import { GridContainer, GridItem, VerticalFunctionsContainer } from './ListParticipants.styles'
import PropTypes from 'prop-types'
import { Typography, useViewport } from '@chilecompra/react-kit'

/**
 * The Participant Functions Details.
 */
const ListParticipantsFunctionsDetails = props => {
  const { data } = props
  const {
    size: { isDownToMedium }
  } = useViewport()

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Typography fontSize={isDownToMedium ? '18px' : '22px'} color="black1" fontWeight="bold" lineHeight="22px">
          Detalle de las funciones
        </Typography>
      </GridItem>
      <GridItem
        xs={12}
        padding={isDownToMedium ? '10px 0 5px' : '10px 0 14px'}
        fontSize={isDownToMedium ? '14px' : '16px'}
        variant="body2"
        lineHeight="21px"
      >
        Revisa la definición de cada una de las funciones que puede tener una persona en un proceso de compra o
        contratación.
      </GridItem>
      <VerticalFunctionsContainer container xs={12} md={6}>
        {data
          .filter((_, index) => index % 2 === 0)
          .map(({ name, description, functionId }) => (
            <GridItem xs={12} key={`function-${functionId}`}>
              <Typography
                lineHeight="21px"
                fontSize={isDownToMedium ? '14px' : '16px'}
                fontWeight="bold"
                padding={isDownToMedium ? '0' : '0 10px 10px 0'}
              >
                {name}:
              </Typography>
              <Typography
                lineHeight="21px"
                fontSize={isDownToMedium ? '14px' : '16px'}
                variant="body2"
                padding={isDownToMedium ? '0 15px 5px 0' : '0 15px 24px 0'}
              >
                {description}
              </Typography>
            </GridItem>
          ))}
      </VerticalFunctionsContainer>
      <VerticalFunctionsContainer container xs={12} md={6}>
        {data
          .filter((_, index) => index % 2 !== 0)
          .map(({ name, description, functionId }) => (
            <GridItem xs={12} key={`function-${functionId}`}>
              <Typography
                lineHeight="21px"
                fontSize={isDownToMedium ? '14px' : '16px'}
                fontWeight="bold"
                padding={isDownToMedium ? '0' : '0 10px 10px 0'}
              >
                {name}:
              </Typography>
              <Typography
                lineHeight="21px"
                fontSize={isDownToMedium ? '14px' : '16px'}
                variant="body2"
                padding={isDownToMedium ? '0 15px 5px 0' : '0 0 24px 0'}
              >
                {description}
              </Typography>
            </GridItem>
          ))}
      </VerticalFunctionsContainer>
    </GridContainer>
  )
}

ListParticipantsFunctionsDetails.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.number.isRequired,
      description: PropTypes.string.isRequired,
      functionId: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired
}

ListParticipantsFunctionsDetails.defaultProps = {
  data: [
    {
      active: 0,
      description: 'Default description',
      functionId: 0,
      name: 'Default name'
    }
  ]
}

export default ListParticipantsFunctionsDetails
